export default __webpack_public_path__ + "static/iso-136fed665eda604dc3dc1aab1ce39c3c.png";